import React, { useState } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@material-ui/core";
import { FieldValidationError, ValidationHelper } from "../../../services/server/ServerResponses";
import { BuilderAssetService, SaveBuilderAssetRequest } from "../../../services/BuilderAssetService";
import { useLibrary, useLibraryAlert } from "../LibraryPage";
import { AssetCategory } from "../../../entities/AssetCategory";
import { UserAgent } from "../../../utilities/UserAgent";
import { useHistory } from "react-router-dom";
import { routes } from "../../../routes";
import { LibraryItem } from "../../../entities/LibraryItem";

interface Props {
    focusedItem: LibraryItem;
    open: boolean;
    onClose: () => void;
}

export function UseTemplateDialog(props:Props){
    const history = useHistory();
    const libraryAlert = useLibraryAlert();
    const context = useLibrary();
    
    const { focusedItem } = props;
    const [newTitle, setNewTitle] = useState(focusedItem.name);
    const [validationErrors, setValidationErrors] = useState<FieldValidationError[]>([]);
    const [disabled, setDisabled] = useState(false);

    const handleAdd = async() => {
        if(newTitle.length === 0)
            return setValidationErrors([{field: "Name", errors: ["Name cannot be blank"]}])

        //TODO: make this server side.
        const request: SaveBuilderAssetRequest = {
            parentId: context.activeFolderId ?? undefined,
            name: newTitle,
            isStarred: false,
            dateAccessed: new Date(),
            category: focusedItem.category ?? AssetCategory.Manuscript,
            text: focusedItem.templateText!,
            slideCount: 0,
            isTemplate: false,
            templateDescription: "",
            customSlideBackgroundImagePath: focusedItem.customSlideBackgroundImagePath,
            slideExporterAspectRatio: focusedItem.slideExporterAspectRatio,
            offlineMode: false,
            lastModifiedFormFactor: UserAgent.getFormFactor(),
            lastModifiedOnOperatingSystem: UserAgent.getOperatingSystem(),
        };

        setDisabled(true);
        const response = await BuilderAssetService.saveFromTemplate(request);
        setDisabled(false);
        
        if(response.error) return libraryAlert(response.message);
        
        if(response.success)
            history.push(routes.app.resolve.builderPage(response.data.id), { prevUrl: window.location.href });
    }

    return (
        <Dialog
            open={props.open}
            onClose={props.onClose}
            aria-labelledby="rename-form-dialog-title"
            disableBackdropClick={disabled}
            disableEscapeKeyDown={disabled}
        >
            <DialogTitle id="rename-form-dialog-title">Enter the name of your new {focusedItem.category ?? "Sermon Manuscript"}</DialogTitle>
            <DialogContent>
                <TextField
                    autoFocus
                    margin="dense"
                    id="renameField"
                    label="Name"
                    type="text"
                    disabled={disabled}
                    style={{ minWidth: "400px" }}
                    fullWidth
                    value={newTitle}
                    onChange={(e) => setNewTitle(e.currentTarget.value)}
                    error={ValidationHelper.isFieldInError(validationErrors, "Name")}
                    helperText={<span>{ValidationHelper.getFieldErrorSummary(validationErrors, "Name") }</span>}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={props.onClose} disabled={disabled} color="primary">
                    Cancel
                    </Button>
                <Button color="primary" disabled={disabled} onClick={() => handleAdd()}>
                    Add
                </Button>
            </DialogActions>
        </Dialog>
    );
}